import { render, staticRenderFns } from "./FaultsWidget.vue?vue&type=template&id=517bd6d0&scoped=true"
import script from "./FaultsWidget.vue?vue&type=script&lang=js"
export * from "./FaultsWidget.vue?vue&type=script&lang=js"
import style0 from "./FaultsWidget.vue?vue&type=style&index=0&id=517bd6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517bd6d0",
  null
  
)

export default component.exports